import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HubUser } from "@appcore/models/user";
import { Observable } from "rxjs";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";

const API_URL = API.API_URL;

@Injectable({ providedIn: "root" })
export class UserService {
  private _handshakeURL = `${API_URL}/handshake`;

  constructor(private httpManager: HttpManager, private router: Router) { }

  reconcileUser(body: HubUser): Observable<any> {
    return this.httpManager.httpPost<any>(`${this._handshakeURL}/reconcileuser`, body);
  }

  setUserProfile(body: HubUser): Observable<any> {
    return this.httpManager.httpPost<any>(`${this._handshakeURL}/setuserprofile`, body);
  }

  getUser(userID: string): Observable<HubUser[]> {
    return this.httpManager.httpGet<HubUser[]>(`${this._handshakeURL}/getuser`, { userID: userID });
  }

  getAll(): Observable<HubUser[]> {
    return this.httpManager.httpGet<HubUser[]>(API_URL + "/users");
  }

  getById(id: number): Observable<HubUser> {
    return this.httpManager.httpGet<HubUser>(API_URL + `/users/${id}`);
  }

  /*
  register(user: User) {
      return this.http.post(this.apiUrl + '/authorgregister', user);
  }
  */

  register(orgID: string, password: string): Observable<any> {
    return this.httpManager.httpPost<any>(API_URL + "/authorgregister", { orgID, password });
  }

  update(user: HubUser): Observable<any> {
    return this.httpManager.httpPut<any>(API_URL + `/authorgmodify/${user.UserName}`, user);
  }

  delete(id: number): Observable<any> {
    return this.httpManager.httpDelete<any>(API_URL + `/authorgdelete/${id}`);
  }
}
